import { Checkbox, Spacer, Text } from '@sparemin/blockhead';
import React from 'react';
import { contains, without } from 'underscore';
import InputLabel from 'components/Form/InputLabel';
import { BlueskyCustomReplyAudience } from 'redux/middleware/api/podcast-service';
import { block } from '../utils';
import { CustomReplyAudience } from './types';

export type BlueskyCustomReplyAudiencesProps = {
  value: BlueskyCustomReplyAudience[];
  onChange: (value: BlueskyCustomReplyAudience[]) => void;
};

const BlueskyCustomReplyAudiences: React.FC<BlueskyCustomReplyAudiencesProps> = ({
  value,
  onChange,
}) => {
  const customReplyAudiences: CustomReplyAudience[] = [
    {
      label: 'Mentioned users',
      value: 'mentionedUsers',
      isSelected: value.includes('mentionedUsers'),
    },
    {
      label: 'Users you follow',
      value: 'following',
      isSelected: value.includes('following'),
    },
    {
      label: 'Your followers',
      value: 'follower',
      isSelected: value.includes('follower'),
    },
  ];

  const handleChange = (option: BlueskyCustomReplyAudience): void => {
    return contains(value, option)
      ? onChange(without(value, option))
      : onChange([...value, option]);
  };

  return (
    <div>
      <InputLabel className={block('extra-reply-options-label')}>
        Or, combine these options:
      </InputLabel>

      <Spacer orientation="vertical" align="flex-start" space="20px">
        {customReplyAudiences.map(
          ({ label, value: settingValue, isSelected }) => (
            <Checkbox
              isSelected={isSelected}
              onChange={() => handleChange(settingValue)}
            >
              <Spacer orientation="vertical" align="flex-start" space="6px">
                <Text variant="label" className={block('extra-reply-option')}>
                  {label}
                </Text>
              </Spacer>
            </Checkbox>
          ),
        )}
      </Spacer>
    </div>
  );
};

export default BlueskyCustomReplyAudiences;
